import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from "axios";
import { sortBy, update } from 'lodash';
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {

  },
  state: {
    user:{
      last_activity: null,
    },
    map: {
      demographics: [],
      chargingPoints: [],
      drawer: false,
      satellite: 'hybrid',
      filters: {
        showMarkers: ['Out of town', 'Leisure', 'Shopping centres', 'Shops'],
        showAllMarkers: true,
        groupByScheme: false,
        googleLabels: false,
        demographicsView: false,
        chargingPointsView: false,
        showCircles: false,
      },
      layers: [],
    },
    companies: {
      filters: {
        search: '',
        tableType: 'all',

        isOutOfTownFilter: null,
        isLeisureFilter: null,
        isFoodStoreFilter: null,
      }
    },
    options: {
      enquiryByProperty: {
        perPage: 50,
        page: 1,
        sortBy: [],
        sortDesc: [],
      }
    },
    properties: {
      filters: {
        tableType: 'all',
        search: '',

        landlordFilter: null,
        landlordAgentFilter: null,
        tenantFilter: null,
        tenantLegalFilter: null,
        tenantContactFilter: null,
        landlordContactFilter: null,
        landlordAgentContactFilter: null,
        tenantAgentFilter: null,
        tenantContactAgentFilter: null,
        vacantFilter: false,
        letFilter: false,
        addressConfirmedFilter: null,
        subscribedFilter: null,
        showUnverified: false,
        sizeFrom: null,
        sizeTo: null,
        rentFrom: null,
        rentTo: null,
        leaseStartFrom: null,
        leaseStartTo: null,
        leaseEndFrom: null,
        leaseEndTo: null,
      }
    },
    schemes: {
      filters: {
        search: '',
        tableType: 'all',

        landlordFilter: null,
        landlordAgentFilter: null,
        tenantFilter: null,
        tenantContactFilter: null,
        landlordContactFilter: null,
        landlordAgentContactFilter: null,
        leaseDataExistsFilter: null,
        tenantAgentFilter: null,
        tenantContactAgentFilter: null,
        legalTenantFilter: null,

      }
    },
    notifications: {
      unread: 0,
    },
  },
  mutations: {
    setActivity(state, payload) {
      Vue.set(state.user, 'last_activity', payload);
    },

    updateActivity(state) {
      // format YYYY-MM-DD HH:MM:SS
      Vue.set(state.user, 'last_activity', new Date().toISOString().slice(0, 19).replace('T', ' '));
    },

    setNotificationsCount(state, payload) {
      state.notifications.unread = payload;
    },
    addMapLayer(state, payload) {
      // state.map.layers.push(payload);
      // state.map.layers.forEach(layer => layer.markers = []);
      Vue.set(state.map.layers, state.map.layers.length, payload);
    },
    removeMapLayer(state, index) {
      // state.map.layers.splice(index, 1);
      // state.map.layers.forEach(layer => layer.markers = []);
      Vue.delete(state.map.layers, index);
    },
    updateMapLayer(state, payload) {
      // console.log(state)
      // payload.markers = [];
      // state.map.layers[payload.index] = payload.layer
      console.log('updateMapLayer', payload)
      Vue.set(state.map.layers, payload.index, payload.layer);
    },

    setOptions(state, payload) {
      state.options[payload.key] = payload.value;
      console.log('setOptions', state.options)
    },

    setDemographics(state, payload) {
      state.map.demographics = payload
    },
    setChargingPoints(state, payload) {
      state.map.chargingPoints = payload
    },
    updateMapFilters(state, payload) {
      state.map.filters[payload.key] = payload.value
    },
    updatePropertiesFilters(state, payload) {
      state.properties.filters[payload.key] = payload.value
    },
    updateMapDrawer(state, payload) {
      state.map.drawer = payload;
    },

    updateMapSatellite(state, payload) {
      state.map.satellite = payload;
    },

    resetPropertiesFilters(state) {
      state.properties.filters = {
        search: '',
        landlordFilter: null,
        landlordAgentFilter: null,
        tenantFilter: null,
        tenantLegalFilter: null,
        tenantContactFilter: null,
        landlordContactFilter: null,
        landlordAgentContactFilter: null,
        vacantFilter: false,
        letFilter: false,
        addressConfirmedFilter: null,
        sizeFrom: null,
        sizeTo: null,
        rentFrom: null,
        rentTo: null,
        leaseStartFrom: null,
        leaseStartTo: null,
        leaseEndFrom: null,
        leaseEndTo: null,
      }
    },
    resetSchemesFilters(state) {
      state.schemes.filters = {
        search: '',
        landlordFilter: null,
        landlordAgentFilter: null,
        tenantFilter: null,
        tenantContactFilter: null,
        landlordContactFilter: null,
        landlordAgentContactFilter: null,
        tenantAgentFilter: null,
        tenantContactAgentFilter: null,
        legalTenantFilter: null,
        leaseDataExistsFilter: null,
      }
    },
    updateSchemesFilters(state, payload) {
      state.schemes.filters[payload.key] = payload.value
    },
    updateCompaniesFilters(state, payload) {
      state.companies.filters[payload.key] = payload.value
    },
    resetCompaniesFilters(state) {
      state.companies.filters = {
        search: '',
        isOutOfTownFilter: null,
        isLeisureFilter: null,
        isFoodStoreFilter: null,
      }
    }
  },
  actions: {
    async getNotificationsCount(context) {
      const response = await axios.get(`/notifications/unread-count`);
      context.commit('setNotificationsCount', response.data.unread_count);
    },
    async getDemographics(context) {
      // const response = await axios.get('/demographics');
      // context.commit('setDemographics', response.data.data);
      context.commit('setDemographics', []);
    },
    async getChargingPoints(context) {
      context.commit('setChargingPoints', [])
      // const response = await axios.get('/charging-points');
      // let chargingPointsMarkers = response.data.data;
      //
      // if (response.data.meta.pagination.total_pages > 1) {
      //   for (let i = 2; i <= response.data.meta.pagination.total_pages; i++) {
      //     const chunkResponse = await axios.get('/charging-points', {
      //       params: {
      //         page: i,
      //       }
      //     });
      //
      //     chargingPointsMarkers = chargingPointsMarkers.concat(chunkResponse.data.data);
      //   }
      // }
      //
      // context.commit('setChargingPoints', chargingPointsMarkers);
    }
  },
  getters: {

  },
  plugins: [createPersistedState()]
})
